/**
 * Default page javascript. All other pages extend this one.
 */

import "core-js/modules/es.promise";

// Polyfill
import arrayFindPolyfill from "./arrayFind";
import smoothscroll from "smoothscroll-polyfill";

// Libs
import whenDomReady from "when-dom-ready";

import siteConfig from "./siteConfig";
import extend from "./extend";

// Styles
import "../../css/pages/BasePage.scss";

class BasePage {
    constructor(...opts) {
        extend(this, opts);
        this.init();
    }

    init() {
        const self = this;
        self.ready = false;
        self.onBeforeReady();

        whenDomReady().then(function () {
            self.onReady();
        });

        window.addEventListener("load", function () {
            self.onLoad();
        });
        smoothscroll.polyfill();
    }

    onBeforeReady() {
        extend(this, siteConfig);
        arrayFindPolyfill();
    }

    onReady() {
        const self = this;
        self.ready = true;
    }

    onLoad() {
        document.getElementsByTagName("body")[0].classList.add("loaded");
    }

    isReady() {
        var self = this;
        return self.ready === true;
    }

    noop() {}
}

export default BasePage;
